import { render, staticRenderFns } from "./TimelineIcon.vue?vue&type=template&id=84e2c0d4"
import script from "./TimelineIcon.vue?vue&type=script&lang=js"
export * from "./TimelineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports